// extracted by mini-css-extract-plugin
export default {"dropdownOrList":"ProductLinks_dropdownOrList__af9Td","list":"ProductLinks_list__XTzz5","button":"ProductLinks_button__J99fB","active":"ProductLinks_active__Nfm4w"};